<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <h2>LiveKit track processor sample</h2>
        <br />
        <div id="connect-area">
          <div>
            <b>LiveKit URL</b>
          </div>
          <div>
            <input type="text" class="form-control" id="url" v-model="room.websocket" />
          </div>
          <div>
            <b>Token</b>
          </div>
          <div>
            <input type="text" class="form-control" id="token" v-model="room.callToken" />
          </div>
        </div>

        <!-- actions -->
        <div id="actions-area">
          <div>
            <button id="connect-button" class="btn btn-primary mt-1" type="button" @click="connectWithFormInput">
              Connect
            </button>
          </div>
          <div>
            <button id="toggle-audio-button" class="btn btn-secondary mt-1" :disabled="!isConnected" type="button" @click="toggleAudio">
              Enable Mic
            </button>
            <button id="toggle-video-button" class="btn btn-secondary mt-1" :disabled="!isConnected" type="button" @click="toggleVideo">
              Enable Camera
            </button>
            <button id="toggle-blur-button" class="btn btn-secondary mt-1" :disabled="!isConnected" type="button" @click="toggleBlur">
              Toggle BackgroundBlur
            </button>
            <button id="toggle-virtual-bg-button" class="btn btn-secondary mt-1" :disabled="!isConnected" type="button" @click="toggleVirtualBackground">
              Toggle Virtual Background
            </button>
            <button id="flip-video-button" class="btn btn-secondary mt-1" type="button" @click="flipVideo">
              Flip Video
            </button>

            <button id="update-bg-button" class="btn btn-secondary mt-1" type="button" @click="updateBackgroundImage">
              Update Background Image
            </button>

            <button id="disconnect-room-button" class="btn btn-danger mt-1" :disabled="!isConnected" type="button" @click="disconnectRoom">
              Disconnect
            </button>
            <button id="start-audio-button" class="btn btn-secondary mt-1" :disabled="!isConnected" type="button" @click="startAudio">
              Start Audio
            </button>
          </div>
        </div>

        <div id="inputs-area">
          <div>
            <select id="video-input" class="custom-select" @change="handleDeviceSelected($event)">
              <option selected>Video Input (default)</option>
            </select>
          </div>
          <div>
            <select id="audio-input" class="custom-select" @change="handleDeviceSelected($event)">
              <option selected>Audio Input (default)</option>
            </select>
          </div>
          <div>
            <select id="audio-output" class="custom-select" @change="handleDeviceSelected($event)">
              <option selected>Audio Output (default)</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div id="participants-area"></div>

    <div id="log-area">
      <textarea id="log"></textarea>
    </div>
  </div>
</template>

<script>
import appActions from './sample.js';
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const room = reactive({
      callId: store.getters['call/chatId'],
      callRoom: store.getters['call/room'],
      callRoomName: store.getters['call/name'],
      websocket: store.getters['call/websocket'],
      callToken: store.getters['call/accessToken'],
      userId: store.getters['call/userId'],
      mode: store.getters['call/mode'],
    });

    const isConnected = computed(() => !!appActions.currentRoom); // Check if a room connection exists

    // Wrapper methods to call appActions functions
    const connectWithFormInput = () => {
      appActions.connectWithFormInput();
    };

    const toggleAudio = () => {
      appActions.toggleAudio();
    };

    const toggleVideo = () => {
      appActions.toggleVideo();
    };

    const toggleBlur = () => {
      appActions.toggleBlur();
    };

    const toggleVirtualBackground = () => {
      appActions.toggleVirtualBackground();
    };

    const flipVideo = () => {
      appActions.flipVideo();
    };

    const updateBackgroundImage = () => {
      appActions.updateVirtualBackgroundImage('/ali-kazal-tbw_KQE3Cbg-unsplash.jpg');
    };

    const disconnectRoom = () => {
      appActions.disconnectRoom();
    };

    const startAudio = () => {
      appActions.startAudio();
    };

    const handleDeviceSelected = (event) => {
      appActions.handleDeviceSelected(event);
    };

    return {
      room,
      isConnected,
      connectWithFormInput,
      toggleAudio,
      toggleVideo,
      toggleBlur,
      toggleVirtualBackground,
      flipVideo,
      updateBackgroundImage,
      disconnectRoom,
      startAudio,
      handleDeviceSelected,
    };
  },
};
</script>
